var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrawerMediaLibrary = function SvgDrawerMediaLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.676 12.858a2.424 2.424 0 1 0 0-4.847 2.424 2.424 0 0 0 0 4.847Zm0-3.3a.877.877 0 1 1 0 1.754.877.877 0 0 1 0-1.754Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m22.369 18.077.013.007a2.836 2.836 0 0 1-2.808 2.508H6.426a2.836 2.836 0 0 1-2.836-2.835V8.244a2.836 2.836 0 0 1 2.836-2.836l1.632.044.025-.018h11.491a2.836 2.836 0 0 1 2.836 2.835l-.041 9.808ZM6.452 6.98h13.122a1.29 1.29 0 0 1 1.29 1.29v3.686l-6.085 3.532-4.46-3.893a.774.774 0 0 0-.98-.052l-4.176 3.068V8.27a1.289 1.289 0 0 1 1.29-1.289Zm13.122 12.066H6.452a1.289 1.289 0 0 1-1.289-1.29V16.52l4.615-3.351 4.434 3.867a.773.773 0 0 0 .902.077l5.75-3.377v4.022a1.29 1.29 0 0 1-1.29 1.289Z",
    fill: "currentColor"
  })));
};
export default SvgDrawerMediaLibrary;